var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseAllStaff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3977 15.5C17.239 14.7937 18.4089 14.3026 20.0361 14.3026C24.3324 14.3026 25.4415 17.7268 25.7278 19.4947C25.8194 20.0602 25.356 20.5244 24.7745 20.5244H22",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3417 15.5C13.5004 14.7937 12.3304 14.3026 10.7033 14.3026C6.40696 14.3026 5.29786 17.7268 5.01156 19.4947C4.91995 20.0602 5.38336 20.5244 5.96492 20.5244H8.73938",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3697 13.2218C17.0878 13.2218 18.4806 11.829 18.4806 10.1109C18.4806 8.3928 17.0878 7 15.3697 7C13.6516 7 12.2588 8.3928 12.2588 10.1109C12.2588 11.829 13.6516 13.2218 15.3697 13.2218Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2163 8.52803C18.6045 8.20236 19.0806 7.99914 19.5841 7.94394C20.0878 7.8888 20.5965 7.98424 21.0459 8.21819C21.4952 8.4521 21.8652 8.81408 22.1089 9.25828C22.3526 9.70247 22.4591 10.209 22.415 10.7137C22.3708 11.2184 22.1779 11.6987 21.8609 12.0938C21.5437 12.489 21.1165 12.7812 20.6333 12.9335C20.1501 13.0859 19.6326 13.0915 19.1462 12.9498C18.6598 12.808 18.2264 12.5252 17.9007 12.137",
    stroke: "#F4F4F9",
    strokeWidth: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.523 8.52803C12.1349 8.20237 11.6589 7.99912 11.1552 7.94395C10.6516 7.8888 10.1429 7.98423 9.69351 8.21817C9.2441 8.45212 8.87416 8.81408 8.63046 9.25827C8.38677 9.70247 8.28027 10.209 8.32442 10.7137C8.36858 11.2184 8.56142 11.6987 8.87854 12.0938C9.19567 12.489 9.62284 12.7812 10.106 12.9335C10.5892 13.0859 11.1068 13.0915 11.5932 12.9498C12.0796 12.808 12.513 12.5251 12.8387 12.137",
    stroke: "#F4F4F9",
    strokeWidth: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3697 15.696C20.3941 15.696 21.6911 19.7623 22.0259 21.8616C22.1331 22.5332 21.5911 23.0844 20.911 23.0844H9.82841C9.14832 23.0844 8.6064 22.5332 8.71351 21.8616C9.0483 19.7623 10.3453 15.696 15.3697 15.696Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseAllStaff);
export default __webpack_public_path__ + "static/media/CollapseAllStaff.36d61fd3e4ff30f5c2a8e9013c8906b7.svg";
export { ForwardRef as ReactComponent };